export enum AuthRoles {
    MODERATOR = 'moderator',
    ADMIN = 'admin',
    SUPERADMIN = 'superadmin',
}
